import React, {FunctionComponent, useContext, useMemo, Fragment} from 'react';
import {Context} from "../../../store/context";
import {ITranslation} from "../../../store/uiTranslations";
import {observer} from "mobx-react";

interface ITranslatedText {
    source: ITranslation
}

export const useTranslation = (source: ITranslation) => {
    const {languagesStore, uiContentsStore} = useContext(Context);
    const {currentIETF} = languagesStore;
    const {uiContents} = uiContentsStore;

    const translation = useMemo(()=>{
        if(!uiContents || !currentIETF)
            return '';

        const content = uiContents.find(c => c.id === source.id);
        const uiName = content?.defaultUiNames.find(ui => ui.lang === currentIETF);

        return uiName ? uiName.name : source.default;
    }, [uiContents, currentIETF, source.id])

    return translation
} 

const TranslatedText:FunctionComponent<ITranslatedText> = ({source}) =>{
    const translation = useTranslation(source)

    return <Fragment>{translation}</Fragment>;
};

export default observer(TranslatedText);
